import { render } from "./Table2Charts.vue?vue&type=template&id=a6452926&scoped=true"
import script from "./Table2Charts.vue?vue&type=script&lang=js"
export * from "./Table2Charts.vue?vue&type=script&lang=js"

import "./Table2Charts.vue?vue&type=style&index=0&id=a6452926&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6452926"]])

export default __exports__